import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { LoadingDialog } from "../../../../_metronic/_partials/controls";

type RootState = {
  notifications: {
    listLoading: boolean;
  };
};

export function NotificationsLoadingDialog() {
  const { isLoading } = useSelector(
    (state: RootState) => ({ isLoading: state.notifications.listLoading }),
    shallowEqual
  );

  return <LoadingDialog isLoading={isLoading} />;
}
